// Foundations
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

// Models
import { LocationRadioOption } from 'src/app/models/location-radio-option.model';
import { FranchiseLocation } from 'src/app/models/franchise.model';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { GoogleMapsService } from 'src/app/services/google-maps.service';

// Components
import { CampDetailsDialogComponent } from '../../camp-details-dialog/camp-details-dialog.component';

@Component({
  selector: 'app-landing-location-tile',
  templateUrl: './landing-location-tile.component.html',
  styleUrls: ['./landing-location-tile.component.scss'],
})
export class LandingLocationTileComponent implements OnInit {
  @Input() location: LocationRadioOption;
  @Input() locationData: FranchiseLocation;
  @Input() isPreferred = true;

  constructor(
    private router: Router,
    public googleMapsService: GoogleMapsService,
    private _analytics: AnalyticsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  viewCampDetails() {
    this._analytics.logButtonTap('landing_campDetails');

    this.dialog.open(CampDetailsDialogComponent, {
      data: {
        locationData: this.locationData,
        isPreferred: this.isPreferred,
      },
      panelClass: 'camp-details-dialog',
    });
  }

  bookReserv() {
    this._analytics.logButtonTap('landing_bookReservation');

    this.router.navigate(['/reservation'], {
      queryParams: { campId: this.locationData.id },
    });
  }

  navigateToInterviewRequest() {
    this._analytics.logButtonTap('landing_requestInterview');

    this.router.navigate(['/interview-request'], {
      queryParams: { campId: this.locationData.id },
    });
  }
}
